export default __webpack_public_path__ + "static/media/peer5.56e78c6d.svg";